import { apiRequest } from '@/common/utils/request.common'
import {
  API_BASE_URL_ACCOUNT,
  HTTP_METHOD_DELETE,
} from '@/common/utils/request.const'

export const deleteDevice = async ({ id }) => {
  try {
    if (!id) return { error: 'id is required' }
    const response = await apiRequest({
      url: `${API_BASE_URL_ACCOUNT}/v1/devices/${id}/tokens`,
      method: HTTP_METHOD_DELETE,
    })

    if (!response) return { data: undefined }
    return response
  } catch (error) {
    return { error: error.response }
  }
}
